import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { NavigationLinks } from "./components/NavigationLinks";
import { useAppSelector, useAppDispatch } from "../../../../states/hooks";
import { actions, selectIsOpenSidebar } from "../../../../states/appState";
import { ToggleLanguageBtn } from "../components/ToggleLanguageBtn";
import { ToggleThemeBtn } from "../components/ToggleThemeBtn";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { openAppPromoDialog } from "../components/AppPromoDialog";

export const Sidebar = () => {
    const { t } = useTranslation();
    const { setIsOpenSidebar } = actions;
    const dispatch = useAppDispatch();
    const isOpenSidebar = useAppSelector(selectIsOpenSidebar);
    const closeSideDrawer = () => dispatch(setIsOpenSidebar(false));

    return (
        <Drawer
            anchor="top"
            open={isOpenSidebar}
            onClose={closeSideDrawer}
            PaperProps={{ className: "smMobileDrawer" }}
        >
            <Grid container sx={{ p: 2 }} role="presentation">
                <Grid
                    item
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    className="smDrawerHead"
                >
                    <Grid item className="smDrawerBrand">
                        <img src="/logo.png" alt="SignaMining.de Logo" />
                        <div>
                            <Typography component="strong">SignaMining Pool</Typography>
                            <Typography component="small">Navigation</Typography>
                        </div>
                    </Grid>

                    <Grid item>
                        <IconButton
                            aria-label="Menü schließen"
                            size="medium"
                            onClick={closeSideDrawer}
                            className="smDrawerClose"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>

                <Grid item container justifyContent="center" className="smDrawerTools">
                    <ToggleLanguageBtn />
                    <ToggleThemeBtn />
                </Grid>

                <Grid item container className="smDrawerLinks">
                    <NavigationLinks />
                </Grid>


                <Grid item container>
                    <Button
                        className="smAppsDrawerButton"
                        fullWidth
                        startIcon={<PhoneIphoneIcon />}
                        onClick={() => {
                            closeSideDrawer();
                            window.setTimeout(openAppPromoDialog, 180);
                        }}
                        sx={{
                            textTransform: "none",
                            px: 5,
                            py: 1.25,
                            fontSize: 16,
                            mb: 1,
                        }}
                    >
                        Android / iPhone App
                    </Button>
                </Grid>

                <Grid item container>
                    <Link to="/start-mining" style={{ width: "100%" }}>
                        <Button
                            className="smMiningButton"
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={closeSideDrawer}
                            sx={{
                                textTransform: "none",
                                px: 5,
                                py: 1.35,
                                fontSize: 16,
                                my: 2,
                            }}
                        >
                            {t("startMining")}
                        </Button>
                    </Link>
                </Grid>
            </Grid>
        </Drawer>
    );
};
